import { createContext } from 'react';

const NavigationDashboardContext = createContext<number | null>(null);

export default NavigationDashboardContext;
